export class ZFolio{


  ww = 0;
  wh = 0;
  tw = 0;
  th = 0;

  inter_calculate_dims = 0;

  mainOptions = {};

  isotopeSettings = {};

  cthis = null;
  htmlIdentifier = '';
  _selectorCon = null;
  $itemsCon = null;
  $gridSizer = null;
  _excerptContent_initialPortItem = null;
  _tcon_content = null;
  _excerptContent = null;
  _excerptContentCon = null;
  $ = null;

  lcIsPackeryReady = false;

  tempInterSetTransitionAnimation = 0;

  constructor(el, $, o) {
    this.$ = $;
    this.cthis = $(el);

    this.mainOptions = o;
  }

  initZfolio(){

    this.$itemsCon = this.cthis.find('.items').eq(0);

    const zfolioMain = this;
    const o = zfolioMain.mainOptions;

    if (o.outer_con_selector_con) {

      if (o.outer_con_selector_con.off) {

      } else {
        (o.outer_con_selector_con) = $(o.outer_con_selector_con)
      }

      zfolioMain._selectorCon = (o.outer_con_selector_con);
    }



  }

  initZfolioReady(){
    const o = this.mainOptions;
    if (o.settings_mode === 'isotope') {

      this.$itemsCon.prepend('<div class="grid-sizer"></div>');

      this.$gridSizer = this.$itemsCon.find('.grid-sizer').eq(0);
    }

  }

  setIsotopeKey(key, value){

    this.isotopeSettings[key] = value;
  }
  initIsotopeSettings(){

    const isotopeSettings = this.mainOptions.settings_isotope_settings;

    if (this.cthis.hasClass('dzs-l-layout--3-cols')) {
      isotopeSettings.percent_amount = 33.3333;
    }
    if (this.cthis.hasClass('dzs-l-layout--4-cols')) {
      isotopeSettings.percent_amount = 25;
    }
    if (this.cthis.hasClass('dzs-l-layout--6-cols')) {
      isotopeSettings.percent_amount = 16.6666;
    }

    this.isotopeSettings = isotopeSettings;
  }

  applyIsotope(overwriteIsotopeSettings, permanentOverwrite = null){

    if(permanentOverwrite){
      this.isotopeSettings = Object.assign(this.isotopeSettings, permanentOverwrite);
      console.log('ver - ', this.isotopeSettings);
    }

    const isotopeSettings = Object.assign(this.isotopeSettings, overwriteIsotopeSettings || {});


    if(isotopeSettings.layoutMode==='packery' && !this.lcIsPackeryReady){
      isotopeSettings.layoutMode='masonry';
    }

    console.log(isotopeSettings, this.isotopeSettings);
    this.$itemsCon.isotope(isotopeSettings);
  }
}
